import React, { useState, useEffect } from 'react';
import { useAuth } from '@/lib/auth-context';
import { getAuthToken } from '@/lib/api';
import DocumentsPage from './DocumentsPage';
import { Card, CardContent } from '@/components/ui/card';
import { FileText } from 'lucide-react';
import logger from '@/lib/logger';

const MyDocumentsPage = () => {
  const { user } = useAuth();
  const [clientInfo, setClientInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, {
          headers: { 'Authorization': `Bearer ${getAuthToken()}` },
          credentials: 'include',
        });
        if (res.ok) {
          const data = await res.json();
          setClientInfo(data);
        }
      } catch (err) {
        logger.error('Failed to load user info', err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) {
    return (
      <div className="space-y-4">
        {[1, 2].map(i => <div key={i} className="h-32 bg-muted rounded-xl animate-pulse" />)}
      </div>
    );
  }

  if (!clientInfo?.client_id) {
    return (
      <Card>
        <CardContent className="p-8 text-center">
          <FileText className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
          <h3 className="font-semibold mb-1">No documents available</h3>
          <p className="text-sm text-muted-foreground">Your account is not linked to a client profile.</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div data-testid="my-documents-page">
      <DocumentsPage clientId={clientInfo.client_id} clientName={clientInfo.client_name || clientInfo.name || 'My Documents'} />
    </div>
  );
};

export default MyDocumentsPage;
